<!-- Versión móvil -->
<div class="full-container" *ngIf="!isDesktopScreen">
  <div class="general-container fs-6" fxLayout="column">
    <div class="title-container" [ngStyle]="{'background-image': 'url(' + imageUrl + ')'}">
      <div class="title-content">
        <img class="ingood-logo" src="assets/img/ingood_horizontal_negative@2x.png" alt="ingood" />
        <h1 class="text">{{ titleText }}</h1>
      </div>
    </div>

    <div class="section-container">
      <div class="section-container-title">
        <h2 class="section-title">{{ titleSectionInfo }}</h2>
      </div>
      <div class="info-container-screen">
        <div class="screen-container">
          <app-coverage-detail [coverages]="textList" *ngIf="textList?.length > 0"></app-coverage-detail>
        </div>
      </div>
      <div class="info-button-container">
        <app-coverage-info (click)="openMobilepModal()" [title]="titleCoverageInfo"></app-coverage-info>
      </div>
    </div>
  </div>

  <div class="bottom-yellow-container">
    <app-total-price-resume [priceCardConfig]="totalPriceBig" style="width: 100%;"></app-total-price-resume>
    <app-button-basic (onClickButtonEvent)="nextStep()" [bgColor]="'#fd7394'" [textColor]="'white'"
      [width]="'320px'" [buttonText]="'¡Lo quiero!'"></app-button-basic>
  </div>
</div>

<!-- Versión escritorio -->
<div class="full-container" *ngIf="isDesktopScreen">
  <div class="general-container fs-6">
    <div class="first-section">
      <div class="title">
        <div class="title-content">
          <h1 class="text">{{ titleText }}</h1>
          <img class="ingood-logo" src="assets/img/ingood_horizontal_negative@2x.png" alt="ingood" />
        </div>
      </div>
      <div class="section-container-title">
        <h2 class="section-title">{{ titleSectionInfo }}</h2>
      </div>
      <div class="info-container-screen">
        <div class="screen-container">
          <app-coverage-detail [coverages]="textList" *ngIf="textList?.length > 0"></app-coverage-detail>
        </div>
      </div>
      <div class="info-button-container">
        <app-coverage-info (click)="openDesktopModal()" [title]="titleCoverageInfo" [price]="totalPriceBig.annualPrice">
        </app-coverage-info>
      </div>
    </div>
  </div>

  <div class="second-section">
    <img class="imgDesktop" [src]="imageUrl" alt="">
    <div class="bottom-yellow-container">
      <app-total-price-resume [priceCardConfig]="totalPriceBig" style="width: 100%;"></app-total-price-resume>
      <app-button-basic (onClickButtonEvent)="nextStep()" [bgColor]="'#fd7394'" [textColor]="'white'"
        [width]="'320px'" [buttonText]="'¡Lo quiero!'"></app-button-basic>
    </div>
  </div>
</div>
